import Homepage from '@/pages/portal/Homepage'
import ParksPage from '@/pages/portal/ParksPage'
import AboutPage from '@/pages/portal/AboutPage'
import CompaniesPage from '@/pages/portal/CompaniesPage'
import ReadNews from '@/pages/portal/ReadNews'
import ContactPage from '@/pages/portal/Contact'

const routes = [
  {
    path: '/',
    name: 'Homepage',
    component: Homepage,
    meta: { requiresAuthentication: false }
  },
  {
    path: '/parks-page',
    name: 'ParksPage',
    component: ParksPage,
    meta: { requiresAuthentication: false }
  },
  {
    path: '/companies-page',
    name: 'CompaniesPage',
    component: CompaniesPage,
    meta: { requiresAuthentication: false }
  },
  {
    path: '/about-page',
    name: 'AboutPage',
    component: AboutPage,
    meta: { requiresAuthentication: false }
  },
  {
    path: '/read-news/:id',
    name: 'ReadNews',
    component: ReadNews,
    meta: { requiresAuthentication: false },
    props: true
  },
  {
    path: '/contact',
    name: 'ContactPage',
    component: ContactPage,
    meta: { requiresAuthentication: false }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/router/portal.js